import * as moment from 'moment';
import { IEventFilter, IPackageListingState } from '../classes/package-listing';
import { IProduction, IPackage } from '../custom/classes/production';
import { upsertEventFilter } from '../redux-state/actions/package-listing.actions';


export function filterMap<TKey, TValue>(list: Map<TKey, TValue>, filterFunc: (key: TKey) => boolean): Map<TKey, TValue> {
    let resultMap = new Map<TKey, TValue>();

    list.forEach((val, key) => {
        if (filterFunc(key)) {
            resultMap.set(key, val);
        }
    })

    return resultMap;
}

export function filterMapByValue<TKey, TValue>(list: Map<TKey, TValue>, filterFunc: (value: TValue) => boolean): Map<TKey, TValue> {
    let resultMap = new Map<TKey, TValue>();

    list.forEach((val, key) => {
        if (filterFunc(val)) {
            resultMap.set(key, val);
        }
    })

    return resultMap;
}

export function getByValue(map, searchValue) {
    for (let [key, value] of map.entries()) {
        if (value === searchValue)
            return key;
    }
}

